
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    docsToDelete: Array as PropType<string[]>,
  },
  computed: {
    multipleDocuments(): boolean {
      return this.docsToDelete.length > 1;
    },
  },
});
